const theme = {
  yellow: '#FEBA46',
  teal: '#00687F',
  black: '#222222',
  'light-yellow': '#FFDAA0',
}

export default theme;
